import { render, staticRenderFns } from "./StatList.vue?vue&type=template&id=22fa5896&scoped=true"
import script from "./StatList.vue?vue&type=script&lang=js"
export * from "./StatList.vue?vue&type=script&lang=js"
import style0 from "./StatList.vue?vue&type=style&index=0&id=22fa5896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa5896",
  null
  
)

export default component.exports